<template>
  <div>
    <div class='form-field'>
      <span class='caption'>Schedule:</span>
      <b-form-radio-group
        class='mt-1 custom-control-inline'
        @change='onChangePeriodicity'
        v-model='periodicity'
        :options='periodicityOptions' />
    </div>
    <div v-if="periodicity === 'day_of_month'">
      <div class='form-field pr-sm-3 w-50'>
        <span class='caption'>{{ periodicityOptions['day_of_month'] }}</span>
        <multiselect
          :options='dayNumberOptions'
          :allow-empty='false'
          :searchable='false'
          :multiple='false'
          :close-on-select='true'
          :clear-on-select='false'
          :preserve-search='true'
          :show-labels='false'
          v-model='schedule.monthDay' />
      </div>
    </div>
    <div v-else>
      <div class='d-sm-inline-flex w-100'>
        <div class='form-field pr-sm-3' style='flex: 1'>
          <span class='caption'>Day of week:</span>
          <multiselect
            label='text'
            :options='weekDayNumberOptions'
            :allow-empty='false'
            :searchable='false'
            :multiple='false'
            :close-on-select='true'
            :clear-on-select='false'
            :preserve-search='true'
            :show-labels='false'
            v-model='schedule.dayNumber' />
        </div>
        <div class='form-field' style='flex: 1'>
          <span class='caption'>Week number:</span>
          <multiselect
            :disabled="periodicity === 'weekly'"
            label='text'
            :options='weekNumberOptions'
            :allow-empty='false'
            :searchable='false'
            :multiple='false'
            :close-on-select='true'
            :clear-on-select='false'
            :preserve-search='true'
            :show-labels='false'
            placeholder='-every week-'
            v-model='schedule.weekNumber' />
        </div>
      </div>
    </div>
    <div v-if='schedule.nextGeneration' class='form-field mt-1'>
      <span class='caption'>Next generation:</span>
      <span :class="{'text-danger': changed }">{{ schedule.nextGeneration }}</span>
    </div>
  </div>
</template>

<script>

import Multiselect from 'vue-multiselect'

export default {
  name: 'ConfigSchedule',
  components: { Multiselect },
  props: {
    periodicityOptions: Object,
    weekDayNumberOptions: Array,
    weekNumberOptions: Array,
    select2prefix: String
  },
  data() {
    return {
      schedule: {
        dayNumber: this.weekDayNumberOptions[0],
        monthDay: null,
        weekNumber: 1,
        nextGeneration: null
      },
      periodicity: 'weekly',
      changed: false,
      weekPlaceholder: 'Choose week number',
      week: null,
      dayNumberOptions: Array.from({ length: 31 }, (_, index) => index + 1)
    }
  },
  watch: {
    periodicity() {
      this.changed = true
    },
    'schedule.dayNumber'() {
      this.changed = true
    }
  },
  methods: {
    renderForm(schedule, nextGeneration) {
      this.schedule.nextGeneration = nextGeneration
      this.schedule.dayNumber = this.weekDayNumberOptions[schedule.dayNumber]
      if (schedule.weekNumber) this.schedule.weekNumber = this.weekNumberOptions[schedule.weekNumber - 1]
      else this.schedule.weekNumber = null
      this.periodicity = schedule.periodicity
      this.schedule.monthDay = schedule.monthDay
      this.$nextTick(() => { this.changed = false })
    },
    onChangePeriodicity(periodicity) {
      if (periodicity === 'weekly') {
        this.schedule.weekNumber = null
        this.schedule.monthDay = null
      } else if (periodicity === 'monthly') {
        [this.schedule.weekNumber] = this.weekNumberOptions
        this.schedule.monthNay = null
      } else {
        this.schedule.monthDay = 1
      }
    },
    getSchedule() {
      return {
        periodicity: this.periodicity,
        monthDay: this.schedule.monthDay,
        dayNumber: this.schedule.dayNumber.id,
        weekNumber: this.schedule.weekNumber ? this.schedule.weekNumber.id : null
      }
    }
  }
}
</script>
